import React, { useState, useEffect } from 'react';
import './App.css'; // Import CSS file for styling
import { useNavigate } from 'react-router-dom';
import { PROKIRIKSI_OPTIONS, TABLE_OPTIONS } from './constants';
import { Header, Footer } from './headerFooter';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { getHost } from './config';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";



function RankingPersonalDetails() {
    const navigate = useNavigate();
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token, navigate]);
    // State variables to hold form data
    const [formData, setFormData] = useState({
        table_type: '',
        last_name: '',
        first_name: '',
        father_name: '',
        id_card_number: '',
        table_value: ''
    });

    // State variable to hold API results
    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false); // New loading state

    // Handler for form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Make POST request to your FastAPI endpoint
            const uppercaseData = {
                ...formData,
                last_name: formData.last_name,
                first_name: formData.first_name,
                father_name: formData.father_name,
                // id_card_number if you decide to enable it later
            };
            const url = `${getHost()}/api/personal-ranking`
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(uppercaseData)
            });

            const responseData = await response.json();
            // Update results state with response data
            setResults(responseData.results);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false); // Always stop loading, even on error
        }
    };

    // Handler for form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData(prev => { 
            let updated = { ...prev, [name]: value };

            if (name === "table_type" && value.includes("2025")) {
                updated.table_value = "initial"
            }

            return updated;
        });
    };

    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');

        // Redirect to the login page
        navigate('/', { replace: true });
    }
    
    const isFormValid = formData.last_name !== '' && formData.table_type !== '' && formData.table_value;
    
    return (
        <div id="root">
            <Header handleLogout={handleLogout}/>
            <main className='main-container'>
                <Container className='custom-container'>
                    <Form.Group className="mb-3 pt-3">
                        <Form.Label className='custom-label'>Προκήρυξη διαγωνισμού:</Form.Label>
                        <Form.Select className="custom-form" name="table_type" value={formData.table_type} onChange={handleChange} required>
                            <option value="">Επιλέξτε προκύρηξη διαγωνισμού</option>
                            {PROKIRIKSI_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option> ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>
                            Επώνυμο:
                        </Form.Label>
                        <Form.Control 
                            className="custom-form"
                            // style={{ textTransform: 'uppercase' }} 
                            type="text" 
                            name="last_name" 
                            value={formData.last_name} 
                            onChange={handleChange} 
                            required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>
                            Όνομα <span className="text-danger" style={{ fontSize: '0.875rem' }}>(προαιρετικό πεδίο)</span>:
                        </Form.Label>
                        <Form.Control 
                            className="custom-form"
                            // style={{ textTransform: 'uppercase' }}
                            type="text" 
                            name="first_name" 
                            value={formData.first_name} 
                            onChange={handleChange} 
                            required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>
                            Πατρώνυμο <span className="text-danger" style={{ fontSize: '0.875rem' }}>(προαιρετικό πεδίο)</span>:
                        </Form.Label>
                        <Form.Control 
                            className="custom-form" 
                            // style={{ textTransform: 'uppercase' }}
                            type="text" 
                            name="father_name" 
                            value={formData.father_name} 
                            onChange={handleChange} 
                            required />
                    </Form.Group>
                    {/* <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Α.Δ.Τ.:</Form.Label>
                        <Form.Control className="custom-form" type="text" name="id_card_number" value={formData.id_card_number} onChange={handleChange} required />
                    </Form.Group> */}
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Είδος πίνακα:</Form.Label>
                        <Form.Select 
                            className="custom-form" 
                            name="table_value" 
                            value={formData.table_value} 
                            onChange={handleChange} 
                            required
                        >
                            <option value="">Επιλέξτε πίνακα</option>
                            {TABLE_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option> ))}
                        </Form.Select>
                    </Form.Group>
                    <Button variant="secondary" type="Εύρεση" onClick={handleSubmit} disabled={!isFormValid}>Εύρεση</Button>
                    <p className="text-muted fst-italic small pt-2">
                            <u><b>Παρατηρήσεις</b></u><br/>
                            <ul>
                                <li>Για τις προκηρύξεις του 2025 οι επιλογές <b>Εκκαθαρισμένος Πίνακας (πριν τις 19 Αυγ 2025)</b> και <b>Εκκαθαρισμένος Πίνακας (μετά τις 19 Αυγ 2025)</b> επιστρέφουν τα ίδια αποτελέσματα.</li>
                                <li>Οι εκκαθαρίσεις των πινάκων έχουν γίνει βάσει Επωνύμου, Ονόματος, Πατρωνύμου και Κλάδου. Πιθανή απόκλιση θέσης: 2% - 4%.</li>
                            </ul>
                    </p>
                    {loading && (
                        <div className="text-center mt-3 mb-3">
                            <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                            </div>
                            <div>Φόρτωση αποτελεσμάτων...</div>
                        </div>
                    )}

                    {results && (
                            results.length > 0 ? (
                                <>
                                    <h3 className='my-3'>Αποτελέσματα</h3>
                                    {results.map((result, index) => (
                                        <Card className='custom-card'>
                                            <Card.Body>
                                                <ListGroup className="list-group-flush">
                                                    <ListGroup.Item>Επώνυμο: {result.last_name}</ListGroup.Item>
                                                    <ListGroup.Item>Όνομα: {result.first_name}</ListGroup.Item>
                                                    <ListGroup.Item>Πατρώνυμο: {result.father_name}</ListGroup.Item>
                                                    <ListGroup.Item>Θέση πίνακα: {result.ranking}</ListGroup.Item>
                                                    <ListGroup.Item>Ειδικότητα: {result.specialty}</ListGroup.Item>
                                                    <ListGroup.Item>Μόρια: {result.grade}</ListGroup.Item>
                                                </ListGroup>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </>
                            ) : (
                                <Card className='custom-card'>
                                    <Card.Body>
                                        <Card.Title>Δεν υπάρχουν αποτελέσματα</Card.Title>
                                    </Card.Body>
                                </Card>    
                            )
                            
            )}
                </Container>
            </main>           
            <Footer />

            
        </div>

    );
}

export default RankingPersonalDetails;
